import React, { useMemo, useState } from 'react';
import { shallowEqual, useSelector } from 'umi';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import { PERIODTIMEOBJ } from '@/pages/dashboard/_config/constant';
import { Iprops, TApiParamsBase } from '../../_config/_type';
export default function IngameDlpBreakdownService(props: Iprops) {
  const { style, className, config, children, segmentVal, ...resetProps } = props || {};
  const { api, refreshKey = '', interval, metric = [], byType, topMetric, extMetricMap } = config || {};
  const { by_tab } = props?.data || {};
  const [sortTopMetric, setSortTopMetric] = useState(topMetric);

  const { gameCode } = useSelector((state: any) => ({
    gameCode: state?.dashboard?.currentGame?.game_code
  }), shallowEqual);

  const data = useMemo(() => ({
    gameCode,
    segmentVal,
    sortTopMetric,
    by_tab,
    metric,
    ...resetProps
  }), [by_tab, gameCode, metric, resetProps, segmentVal, sortTopMetric]);

  // 格式化数据
  const transformDataList = (dataList: any[]) => {
    const result = {};
    dataList?.forEach((item: { [x: string]: any; }) => {
      for (const key in item) {
        result[key] = Array.isArray(item[key]) ? item[key] : {};
      }
    });
    return result;
  };

  const formatData = (data: any) => {
    const dwmList = data?.dwm_list || {};
    // metric 有且只能有两个
    const dataList = metric?.map((item) => ({
      [item]: dwmList?.map((meitricsItem: { metrics: { [x: string]: any; }; name: any; full_name: any; value: string; }) => {
        const metricDataItem = meitricsItem?.metrics?.[item];
        const metricContrastDataItem = meitricsItem?.metrics?.[extMetricMap?.[item]];
        // 兼容FTC组件进行数据处理
        return ({
          ...(metricDataItem || {}),
          name: meitricsItem?.name || '',
          full_name: meitricsItem?.full_name || '',
          // 对比的值和百分比
          value_ext1: metricContrastDataItem?.value,
          share_off_all_ext1: metricContrastDataItem?.share_off_all,
        });
      })
    }));
    const dataObj = transformDataList(dataList);
    return {
      ...(dataObj || {}),
      by_type: typeof byType === 'function' ? byType(segmentVal) : byType
    };
  };

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        dataKey={'breakDownData'}
        refreshKey={refreshKey}
        interval={interval}
        formatData={formatData}
        beforeRequest={(data) => {
          const { filterVal, gameCode, segmentVal, sortTopMetric, metric } = data;
          const { singleDaily, timeType, ...filters } = filterVal || {};

          // 传参兜底筛选器参数
          const typeKey = typeof byType === 'function' ? byType(segmentVal) : byType;
          const params: TApiParamsBase = {
            game_code: gameCode,
            filters: formatFilterValues(filters),
            start_time: singleDaily,
            end_time: singleDaily,
            period: PERIODTIMEOBJ[timeType],
            metrics: metric,
            accumulation: {
              [typeKey]: true
            },
            top_metric: sortTopMetric,
          };
          return params;
        }}
        trackData={['gameCode', 'segmentVal', 'sortTopMetric', 'by_tab', 'metric']}
      >
        {React.Children.map(children, (child: any) => React.cloneElement(
          child,
          {
            ...(resetProps || {}),
            extMetricMap,
            segmentVal,
            setSortTopMetric
          }
        ))}
      </Service>
    </div>
  );
};